export function isValid(value) {
  if (value === null || value === undefined) return false;

  if (typeof value === "string" && value.trim() === "") return false;

  if (Array.isArray(value) && value.length === 0) return false;

  if (
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.keys(value).length === 0
  )
    return false;

  return true;
}
